import angular from 'angular';
import NewsletterBoxController from "./form.controller";
import NewsletterButtonController from "./newsletter-button.controller";

let newsletter = angular
    .module('newsletter', [])
    .controller('NewsletterBoxController', NewsletterBoxController)
    .controller('NewsletterButtonController', NewsletterButtonController);

export default newsletter;
